<div class="large-login-container" *ngIf="component.content as content">
  <div class="content">
    <div class="markdown-content">
      <markdown class="markdown" [data]="content"></markdown>
      <div class="btn">
        <kion-button [isLink]="true" [link]="'auth'" [title]="'signIn.button' | translate" [mode]="'primary'" (clicked)="loginClicked()"></kion-button>
      </div>
    </div>
    <div class="image-content" *ngIf="component.logoNew as media">
      <img
        [defaultImage]="media.url + '?width=100&height=100&padColor=fff'"
        [lazyLoad]="media.url + '?width=700&height=700&padColor=fff'"
        [errorImage]="'./assets/ui/shared/error/not_found_error_image.png'"
        [alt]="media.code"
        [title]="media.code"
        src="#"
        width="700"
        height="700" />
    </div>
  </div>
</div>
